module.exports = __webpack_public_path__ + "static/media/avatar-emoji-emoticon-emotion-expression-profile-svgrepo-com.71b72c4a.svg";